export const customFontSizes = {
  'subtitle-medium': [
    '1.3125rem',
    {
      lineHeight: '1.2381',
      fontWeight: '600',
    },
  ],
  'display-small': [
    '2rem',
    {
      lineHeight: '-1.28',
      fontWeight: '700',
    },
  ],
  'display-medium': [
    '2.25rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.09rem',
    },
  ],
  'display-large': [
    '3rem',
    {
      lineHeight: 'normal',
      fontWeight: '700',
    },
  ],
  'headline-large': [
    '1.5rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.06rem',
    },
  ],
  'headline-medium': [
    '1.25rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.05rem',
    },
  ],
  'headline-small': [
    '1.125rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.03rem',
    },
  ],
  'title-large': [
    '0.98rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.01rem',
    },
  ],
  'title-medium': [
    '0.875rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.018rem',
    },
  ],
  'title-small': [
    '0.75rem',
    {
      lineHeight: '1.3',
      fontWeight: '700',
      letterSpacing: '-0.01rem',
    },
  ],
  'body-large': [
    '0.875rem',
    {
      lineHeight: '1.3',
      fontWeight: '500',
      letterSpacing: '-0.018rem',
    },
  ],
  'body-medium': [
    '0.75rem',
    {
      lineHeight: '1.3',
      fontWeight: '500',
      letterSpacing: '-0.015rem',
    },
  ],
  'body-small': [
    '0.625rem',
    {
      lineHeight: '1.3',
      fontWeight: '500',
    },
  ],
  'label-large': [
    '0.875rem',
    {
      lineHeight: '1.3',
      fontWeight: '600',
      letterSpacing: '-0.018rem',
    },
  ],
  'label-medium': [
    '0.75rem',
    {
      lineHeight: '1.3',
      fontWeight: '600',
      letterSpacing: '-0.015rem',
    },
  ],
  'label-small': [
    '0.625rem',
    {
      lineHeight: '1.3',
      fontWeight: '600',
    },
  ],
}
